import { Redis } from 'ioredis';

export async function redisScanKeys(redis: Redis, pattern: string) {
  let cursor = '0';
  const keys = [];

  do {
    const [nextCursor, batchKeys] = await redis.scan(
      cursor,
      'MATCH',
      pattern,
      'COUNT',
      1000
    );
    cursor = nextCursor;
    keys.push(...batchKeys);
  } while (cursor !== '0');

  return keys;
}
